export const awsBucketConfig = {
  accessKeyId: process.env.REACT_APP_AWS_ACCESS_KEY_ID,
  secretAccessKey: process.env.REACT_APP_AWS_SECRET_ACCESS_KEY,
  storageBucketName: "yatter-storage-bucket",
  openStorageBucketName: "wabm-storage-bucket",
  openUploadedFilePrefix: `https://yatter-storage-bucket.s3.ap-south-1.amazonaws.com/`,
  awsRegion: process.env.REACT_APP_AWS_REGION,
};
